module.exports = __webpack_public_path__ + "img/fireBIM_checked.dce1ffd3.png";